module.exports = __webpack_public_path__ + "img/rugby-icon.19cd4178.png";